<template>
    <div class="col-md-12 sales-container">
        <div class="col-md-4 float-left" v-for="(com, index) in this.compras" :key="'compras-' + index">
            <!--
            <card>
                <h4 slot="header" class="card-title text-center">
                    <img style="width: 50%;" :src="[server + com.imagenProducto]" />
                </h4>
            </card> -->
            <card>
                <b>Part Number {{ com.codigoProducto }}</b>
                <br />
                <span v-if="$store.state.lang == 'es'">
                    {{ com.descripcionProductoEs }}
                </span>
                <span v-else-if="$store.state.lang == 'en'">
                    {{ com.descripcionProductoEn }}
                </span>
                <span v-else>
                    {{ com.descripcionProducto }}
                </span>
                <br />
                {{ $t("app.modules.orders.headers.quantity") }}:
                {{ com.cantidad }}
                <span class="sales-units">{{ com.unidadMedida }}</span>
                <div class="text-center">
                    <n-button native-type="submit" type="primary" @click.native="addItemUltimasCompras(com)">
                        {{ $t("app.buttons.add") }}
                    </n-button>
                </div>
            </card>
        </div>

      <div class="col-md-4 float-left" v-if="sugerencia">
        <card>
          <h4 slot="header" class="card-title text-center">
            <img style="width: 50%;" :src="getFirstImageForProduct(sugerencia.product.producto.imagenProducto)" />
          </h4>
        </card>
        <card>
          <div class="row">
            <div class="col-2" style="display: table-cell; vertical-align: middle">
              <i class="now-ui-icons shopping_delivery-fast" style="font-size: 200%;"></i>
            </div>
            <div class="col-10">
              <b>{{ $t('app.product_suggestions.message').replace('{date}', fechaLocalized).replace('{product}', sugerencia.model.material) }}</b>
              <br />
              <span v-if="$store.state.lang == 'es'">
                    {{ sugerencia.product.descripcionProductoEs }}
                </span>
              <span v-else-if="$store.state.lang == 'en'">
                    {{ sugerencia.product.descripcionProductoEn }}
                </span>
              <span v-else>
                    {{ sugerencia.product.descripcionProducto }}
                </span>
              <br />
            </div>
          </div>

          <div class="text-center">
            <n-button native-type="submit" type="primary" @click.native="addItemUltimasComprasIA(sugerencia)">
              {{ $t("app.buttons.add") }}
            </n-button>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import ConstPedidoOrigenCreacion from "@/models/pedidos/ConstPedidoOrigenCreacion";
export default {
    components: {
    },
    computed: {
      fechaLocalized () {
        let fecha = this.sugerencia.model.fecha
        if (this.$store.state.lang === 'es') {
          return this.$moment(fecha, 'DD-MM-YYYY').format('D [de] MMMM [de] YYYY')
        } else {
          return this.$moment(fecha, 'DD-MM-YYYY').locale('en').format('MMMM D, YYYY')
        }
      }
    },
    data() {
        return {

            img: "",
            server: "",
            compras: [],
          sugerencia: null,
          origins: new ConstPedidoOrigenCreacion()
        }
    },
    created() {
        this.server = process.env.VUE_APP_API_ENDPOINT;
    },
    async mounted() {
        await this.getProducts();
    },
    methods: {
      parseJson(icons){
        if (icons) {
          let images = []
          let json = JSON.parse(icons);
          let num = json.length;

          if(num > 0){
            let image = [process.env.VUE_APP_BACK_URL,json[0]].join('/')
            images.push(image)
          }

          return images
        } else {
          return []
        }
      },
      getFirstImageForProduct (images) {
        let imgs = this.parseJson(images)
        if (imgs.length > 0) {
          return imgs[0]
        } else {
          return false
        }
      },
       addItemUltimasCompras(item){
         console.log("Llega aqui");
          var object = new Object({
            producto: {
              textoBreveMaterial : item.descripcionProducto,
              idProducto : item.idProducto,
              codigoProducto: item.codigoProducto
            }
          });
          object.origenCreacion = this.origins.EXPRESSFORM;
          EventBus.$emit("show-add.item-cart", object);
        },
      addItemUltimasComprasIA(el){
        let item = el.product || false
        if (item) {
          item.delivery_date = el.model.fecha || false
          item.origenCreacion = this.origins.RECOMMENDATION;
          console.log(item);
          EventBus.$emit("show-add.item-cart", item);
        }
      },
      async getSugerenciasComprasIA () {
        /*
        await this.$http.get(`${process.env.VUE_APP_API_IA_ENDPOINT}/id/${this.$store.state.user.idCliente}`)
        .then(async response => {
          console.log('IA')
          console.log(response.body)
          if (response.body) {
            for (let key in response.body) {
              let item = response.body[key]
              this.sugerencia = {
                model: item,
                product: await this.getInformacionProducto(item.idProducto)
              }
            }
          }
        }, error => {
          console.log(error)
          this.notifyMessage('danger', this.$t('app.promps.error'))
        })*/
      },
        async getSugerenciasCompras () {
         const params = {
           id: 0,
           claveIdioma: this.$store.state.lang,
           usuario: this.$store.state.user.idUsuario
         }

          console.log('sugerencias compas')
         await this.$http.post(route('SugerenciaCompra/getSugerenciaCompra'), params)
          .then( async response => {
            if (response.body) {
              await this.getInformacionProducto(response.body.idProducto)
            }
          }, error => {
            console.log(error)
            this.notifyMessage('danger', this.$t('app.promps.error'))
          })
        },
      async getInformacionProducto (idProducto) {
         let result = false

         let params = {
           idProducto: idProducto
         }

         await this.$http.post(route('Productos/getInformacionProducto'), params)
        .then(response => {
          result = response.body
        }, error => {
          console.log(error)
          this.notifyMessage('danger', this.$t('app.promps.error'))
        })

        return result
      },
        async getProducts(){
         //await this.getSugerenciasCompras()
          await this.getSugerenciasComprasIA()

            const params = {
                id: this.$store.state.user.idClienteSAP,
                claveIdioma: this.$store.state.lang,
                usuario: this.$store.state.user.idUsuario
            }

            await this.$http.post(route("Pedidos/getUltimosProductosAdquiridosWeb"), params).then(
                (response) => {
                if (response.body.code === 200) {
                    this.compras = response.body.productos
                    .slice(0, 2);
                } else {
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
                },
                (error) => {
                console.error(error);
                this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            );
        },
        addCart(idProductoCliente, cantidad){
            console.log(idProductoCliente, cantidad)
            var payload = {
                idProductoCliente: idProductoCliente,
                cantidad: cantidad,
                fechaEntrega: this.deliveryDate(false)
            }
            EventBus.$emit("add-to-cart", payload);
        },
        deliveryDate(first) {
            var date = new Date();

            var firstDay =
                new Date(date.getFullYear(), date.getMonth(), 1);

            var lastDay =
                new Date(date.getFullYear(), date.getMonth() + 1, 0);

            if(first){
                return firstDay;
            }
            else{
                return lastDay;
            }
        }
    }
}
</script>

<style scoped>

.sales-container{
    margin-top: 20px;
}

.sales-units{
    color: red;
}

</style>
